import { useRef } from 'react';
import { useTabPanel, FocusScope } from 'react-aria';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './TabPanel.module.scss';

const TabPanel = ({ state, ...props }) => {
    const ref = useRef();
    const { tabPanelProps } = useTabPanel(props, state, ref);

    return (
        <FocusScope>
            <div
                className={[
                    styles.panel
                ].join(' ')}
                data-testid={state?.selectedItem?.props['data-testid']
                    ? state?.selectedItem?.props['data-testid'] + '.panel'
                    : null
                }
                role={'tabpanel'}
            >
                <div className={styles.title}>
                    <div
                        className={styles.prefix}
                        data-testid={state?.selectedItem?.props['data-testid']
                            ? state?.selectedItem?.props['data-testid'] + '.prefix'
                            : null
                        }
                    >
                        {state?.selectedItem?.props?.prefix}
                    </div>
                    <h2
                        className={styles.text}
                        data-testid={state?.selectedItem?.props['data-testid']
                            ? state?.selectedItem?.props['data-testid'] + '.title'
                            : null
                        }
                    >
                        {state?.selectedItem?.props?.title}
                    </h2>
                    <div
                        className={styles.suffix}
                        data-testid={state?.selectedItem?.props['data-testid']
                            ? state?.selectedItem?.props['data-testid'] + '.suffix'
                            : null
                        }
                    >
                        {state?.selectedItem?.props?.suffix}
                    </div>
                </div>
                <div
                    ref={ref}
                    {...tabPanelProps}
                    className={styles.wrapper}
                >
                    <div className={styles.inset}>
                        <div className={styles.content} tabIndex={0}>
                            {state?.selectedItem?.props?.children}
                        </div>
                    </div>
                </div>
            </div>
        </FocusScope>
    );
};

TabPanel.propTypes = {
    ...defaultAriaProps
};

export default TabPanel;
